import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, subtitle }) => (
  <Box
    component={motion.div}
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.45, ease: 'easeOut' }}
    sx={{
      py: 8,
      px: 3,
      textAlign: 'center',
      borderRadius: 2,
      border: '1px solid #2F3336',
      backgroundColor: '#16181C',
    }}
  >
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: '50%',
        backgroundColor: '#0F1419',
        border: '1px solid #2F3336',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mx: 'auto',
        mb: 2,
        color: '#71767B',
      }}
    >
      {icon}
    </Box>
    <Typography variant="body1" sx={{ color: '#E7E9EA', fontWeight: 500 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" sx={{ mt: 1, color: '#71767B', maxWidth: 360, mx: 'auto' }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default EmptyState;
